import { Routes, Route } from 'react-router-dom';
import CommunityLayout from '@/components/admin/CommunityLayout';
import CommunityHomePage from '@/pages/community/CommunityHomePage';
import MabarListPage from '@/pages/community/MabarListPage';
import CreateMabarCommunityPage from '@/pages/community/CreateMabarCommunityPage';
import EditMabarCommunityPage from '@/pages/community/EditMabarCommunityPage';
import MabarDetailCommunityPage from '@/pages/community/MabarDetailCommunityPage';
import MabarDashboardPage from '@/pages/community/MabarDashboardPage';
import CommunityTransactionPage from '@/pages/community/CommunityTransactionPage';
import WhatsappNotificationPage from '@/pages/community/WhatsappNotificationPage';
import MabarAnalitikPage from '@/pages/community/MabarAnalitikPage';
import CreateGamePage from '@/pages/community/CreateGamePage';
import BadmintonStatistikPage from '@/pages/community/BadmintonStatistikPage';
import TambahBadmintonGamePage from '@/pages/community/TambahBadmintonGamePage';
import BadmintonEditSkorPage from '@/pages/community/BadmintonEditSkorPage';
import BadmintonSessionDetailPage from '@/pages/community/BadmintonSessionDetailPage';
import PadelStatistikPage from '@/pages/community/PadelStatistikPage';
import TambahPadelGamePage from '@/pages/community/TambahPadelGamePage';
import PadelEditSkorPage from '@/pages/community/PadelEditSkorPage';
import PadelSessionDetailPage from '@/pages/community/PadelSessionDetailPage';
import PickleballStatistikPage from '@/pages/community/PickleballStatistikPage';
import MabarRekapPage from '@/pages/community/MabarRekapPage';
import MabarRekapSelectPlayerPage from '@/pages/community/MabarRekapSelectPlayerPage';
import MabarRekapSelectAssistPage from '@/pages/community/MabarRekapSelectAssistPage';
import BadmintonRekapPage from '@/pages/community/BadmintonRekapPage';
import PadelRekapPage from '@/pages/community/PadelRekapPage';
import MabarHasilPage from '@/pages/community/MabarHasilPage';
import ProfileSettings from '@/pages/community/ProfileSettings';
import EditCommunityInfoPage from '@/pages/community/EditCommunityInfoPage';
import CommunityMenuPage from '@/pages/community/CommunityMenuPage';
import CommunityWallet from '@/pages/community/CommunityWallet';
import CommunityMembersPage from '@/pages/community/CommunityMembersPage';
import HostManagementPage from '@/pages/community/HostManagementPage';
import CashflowManagementPage from '@/pages/community/CashflowManagementPage';
import DeleteAccountPage from '@/pages/DeleteAccountPage';

const CommunityPage = () => {
  return (
    <Routes>
      <Route path="/" element={<CommunityLayout />}>
        <Route index element={<CommunityHomePage />} />
        <Route path="cash" element={<CashflowManagementPage />} />
        <Route path="wallet" element={<CommunityWallet />} />
        <Route path="members" element={<CommunityMembersPage />} />
        <Route path="hosts" element={<HostManagementPage />} />
        <Route path="menu" element={<CommunityMenuPage />} />
        <Route path="profile-settings" element={<ProfileSettings />} />
        <Route path="profile-settings/edit-info" element={<EditCommunityInfoPage />} />
        <Route
          path="profile-settings/delete"
          element={<DeleteAccountPage backTo="/host/profile-settings" />}
        />
        <Route path="mabar" element={<MabarListPage />} />
        <Route path="mabar/create" element={<CreateMabarCommunityPage />} />
        <Route path="mabar/:slug/edit" element={<EditMabarCommunityPage />} />
        <Route path="mabar/:slug/details" element={<MabarDetailCommunityPage />} />
        <Route path="mabar/:slug/dashboard" element={<MabarDashboardPage />} />
        <Route path="transactions" element={<CommunityTransactionPage />} />
        <Route path="whatsapp" element={<WhatsappNotificationPage />} />
        <Route path="mabar/:slug/statistic" element={<MabarAnalitikPage />} />
        <Route path="mabar/:slug/game/create" element={<CreateGamePage />} />
        <Route path="mabar/:slug/game/:gameSlug/edit" element={<CreateGamePage />} />
        <Route path="mabar/:slug/badminton" element={<BadmintonStatistikPage />} />
        <Route path="mabar/:slug/badminton/tambah-game" element={<TambahBadmintonGamePage />} />
        <Route
          path="mabar/:slug/badminton/game/:gameSlug/skor"
          element={<BadmintonEditSkorPage />}
        />
        <Route
          path="mabar/:slug/badminton/session/:sessionSlug"
          element={<BadmintonSessionDetailPage />}
        />
        <Route
          path="mabar/:slug/badminton/session/:sessionSlug/rekap"
          element={<BadmintonSessionDetailPage />}
        />
        <Route path="mabar/badminton/game/:gameSlug/rekap" element={<BadmintonRekapPage />} />
        <Route path="mabar/:slug/padel" element={<PadelStatistikPage />} />
        <Route path="mabar/:slug/padel/tambah-game" element={<TambahPadelGamePage />} />
        <Route
          path="mabar/:slug/padel/game/:gameSlug/skor"
          element={<PadelEditSkorPage />}
        />
        <Route path="mabar/:slug/padel/session/:sessionSlug" element={<PadelSessionDetailPage />} />
        <Route
          path="mabar/:slug/padel/session/:sessionSlug/rekap"
          element={<PadelSessionDetailPage />}
        />
        <Route path="mabar/padel/game/:gameSlug/rekap" element={<PadelRekapPage />} />
        <Route path="mabar/:slug/pickleball" element={<PickleballStatistikPage />} />
        <Route path="mabar/game/:gameSlug/rekap" element={<MabarRekapPage />} />
        <Route
          path="mabar/game/:gameSlug/rekap/select-player"
          element={<MabarRekapSelectPlayerPage />}
        />
        <Route
          path="mabar/game/:gameSlug/rekap/select-assist"
          element={<MabarRekapSelectAssistPage />}
        />
        <Route path="mabar/game/:gameSlug/hasil" element={<MabarHasilPage />} />
        <Route path="profile-settings" element={<ProfileSettings />} />
        <Route
          path="profile-settings/delete"
          element={<DeleteAccountPage backTo="/host/profile-settings" />}
        />
      </Route>
    </Routes>
  );
};

export default CommunityPage;
